// Framework and third-party non-UI
import React from 'react';

// Redux, contexts, and local helpers/utils/modules

// Component specific modules (Component-styled, etc.)

// App components

// Third-party components (buttons, icons, etc.)
import { CalciteStepper } from '@esri/calcite-components-react';

type CalciteStepperWrapperProps = React.ComponentProps<typeof CalciteStepper>;

const CalciteStepperWrapper = ({ ...rest }: CalciteStepperWrapperProps) => {
  return <CalciteStepper {...rest} />;
};

export default CalciteStepperWrapper;
